export const ROOM_LIVE_STATUS = {
  ERROR: "error",
  START: "start",
  STARTED: "started",
  STOP: "stop",
  ROTATE: "rotate"
} as const;

export const ROOM_LIVE_STATUSES = Object.values(ROOM_LIVE_STATUS);
